import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuscadorVersionesModeloComponent } from '../../components/buscador-versiones-modelo/buscador-versiones-modelo.component';

@Component({
	standalone: true,
	imports: [
		CommonModule, 
		BuscadorVersionesModeloComponent],
	templateUrl: './buscador-modelos.view.html',
	styleUrls: ['./buscador-modelos.view.scss'],
	host: {
		'data-view-id': 'buscador-modelos-view'
	}
})
export class BuscadorModelosView {}
